import { useState } from 'react';

function InfoIcon({ className = '' }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={className}>
      <circle cx="12" cy="12" r="9.25" fill="none" stroke="currentColor" strokeWidth="1.75" />
      <path
        d="M12 10.2v5.2M12 8.1h.01"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

/**
 * Botão (i) para exibir `erp_obs` devolvida pelo ERP no PATCH do pedido.
 * @param {{ erpObs?: string | null, size?: 'sm' | 'md' }} props
 */
export function OrderErpObsInfoButton({ erpObs, size = 'md' }) {
  const [open, setOpen] = useState(false);
  const text = String(erpObs ?? '').trim();
  const hasText = text.length > 0;
  const dim = size === 'sm' ? 'h-8 w-8' : 'h-9 w-9';
  const icon = size === 'sm' ? 'h-4 w-4' : 'h-4.5 w-4.5';

  return (
    <>
      <button
        type="button"
        title={hasText ? 'Informação do sistema da loja' : 'Sem informação do sistema'}
        onClick={() => setOpen(true)}
        className={`group inline-flex ${dim} shrink-0 items-center justify-center rounded-full border shadow-sm transition hover:-translate-y-[1px] hover:shadow-md focus:outline-none focus-visible:ring-2 ${
          hasText
            ? 'border-violet-500/40 bg-gradient-to-br from-violet-500/15 via-sky-500/10 to-cyan-500/15 text-violet-800 hover:border-violet-500/60 hover:from-violet-500/25 dark:border-violet-300/35 dark:from-violet-500/20 dark:to-cyan-500/15 dark:text-violet-100 focus-visible:ring-violet-500/45'
            : 'border-ink/12 bg-white/80 text-ink/40 hover:border-ink/20 hover:text-ink/55 dark:border-white/12 dark:bg-white/5 dark:text-mist/40 dark:hover:text-mist/60 focus-visible:ring-ink/20'
        }`}
      >
        <InfoIcon className={`${icon} transition group-hover:scale-110`} />
        <span className="sr-only">Informação do pedido</span>
      </button>

      {open ? (
        <div
          className="fixed inset-0 z-[80] flex items-center justify-center bg-black/50 p-4 backdrop-blur-[2px]"
          role="presentation"
          onClick={() => setOpen(false)}
        >
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="erp-obs-title"
            className="w-full max-w-md rounded-2xl border border-violet-500/25 bg-white p-5 shadow-2xl dark:border-violet-400/20 dark:bg-zinc-900"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-start gap-3">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-violet-500/20 to-cyan-500/20 text-violet-700 dark:text-violet-200">
                <InfoIcon className="h-5 w-5" />
              </div>
              <div className="min-w-0 flex-1">
                <h3 id="erp-obs-title" className="font-display text-lg font-semibold text-ink dark:text-mist">
                  Informação do sistema
                </h3>
                <p className="mt-2 whitespace-pre-wrap text-sm leading-relaxed text-ink/75 dark:text-mist/80">
                  {hasText
                    ? text
                    : 'Ainda não há informação registada pelo sistema da loja para este pedido.'}
                </p>
                <button
                  type="button"
                  onClick={() => setOpen(false)}
                  className="mt-4 rounded-xl bg-zinc-900 px-4 py-2 text-sm font-bold text-white dark:bg-teal-600"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
